import React, { useState } from 'react';
import { TrackInfo } from './TrackInfo';
import { Controls } from './Controls';
import classnames from 'classnames';
import { useNuPlayerContext } from '../NuPlayerContext';
import { useNavigation } from '../../../hooks/useNavigation';
import { useBreakpoints } from '@nutastic/nutastic-react-app';

const componentClass = 'nutasticAudioPlayer';

export const AudioPlayer = ({ className, onCloseClick }) => {
    const { loadPage } = useNavigation();
    const { currentTrack, stopTheMusic, playerConfigData } = useNuPlayerContext();
    const { lg: isLargeScreen } = useBreakpoints();
    const [isFullScreenMode, setIsFullScreenMode] = useState(false);
    const classes = classnames(componentClass, 'animated', className, {
        fullScreenMode: isFullScreenMode,
        'fadeInUp' : isFullScreenMode,
        'slideInUp' : !isLargeScreen && !isFullScreenMode,
        'slideInRight': isLargeScreen && !isFullScreenMode
    });

    const onCloseButtonClick = () => {
        if (onCloseClick) {
            onCloseClick();
        } else {
            stopTheMusic();
        }
    };

    const onGoToClicked = () => {
        setIsFullScreenMode(false);
        loadPage(`/content/music/${playerConfigData?.musicProjectSlug}`);
    };

    const showFullPlayer = () => {
        setIsFullScreenMode(true);
    };

    return currentTrack ? <div className={classes}>
        { !isFullScreenMode  && <div className={`${componentClass}__closeBtn`} onClick={onCloseButtonClick}>
            <i className="ion-md-close-circle"/>
        </div> }
        { isFullScreenMode  && <div className={`${componentClass}__closeBtn`} onClick={() => setIsFullScreenMode(false)}>
            <i className="fa fa-arrow-circle-down"/>
        </div> }
        <TrackInfo onClick={showFullPlayer} />
        { isFullScreenMode && <div className={`${componentClass}__info`}>
            <h3>{ currentTrack.title }</h3>
            <span>{ currentTrack.author }</span>
        </div> }
        <div className={`${componentClass}__controller`}>
            { !isFullScreenMode && <span onClick={showFullPlayer}>
                {currentTrack.title} | {currentTrack.author}
            </span> }
            <Controls hideBackButton={!isLargeScreen && !isFullScreenMode} />
        </div>
        { isFullScreenMode && <div className={`${componentClass}__toGoBtn`}>
            <button className="btn btn-dark-red" onClick={onGoToClicked}>Go To Music</button>
        </div> }
    </div> : null;
};
